<script setup lang="ts">
    import blokStyleClasses from '~/utils/blokStyleClasses';

    const props = defineProps<{ blok: GDoubleRowStoryblok }>();

    const { hidden } = useBlokVisibility(props.blok);

    const gridClasses = computed(() => {
        const {
            customGridWeighting,
            customMargin,
            customMarginDesktop,
            customPadding,
            customPaddingDesktop,
            customGap,
            customGapDesktop,
            customTheme,
            backgroundPosition,
            verticalAlign
        } = blokStyleClasses(props.blok);

        const widthClass = props.blok?.width === 'fullWidth' ? '--full-width' : '';
        const marginClass = props.blok?.margin !== 'default' ? customMargin : '';
        const marginDesktopClass = props.blok?.marginDesktop ? customMarginDesktop : '';
        const paddingClass = customPadding;
        const paddingDesktopClass = props.blok?.paddingDesktop ? customPaddingDesktop : '';
        const gapClass = props.blok?.gap !== 'default' ? customGap : '';
        const gapDesktopClass = props.blok?.gapDesktop && props.blok?.gapDesktop !== 'default' ? customGapDesktop : '';
        const themeRoundCornersClass = props.blok?.themeRoundCorners ? '--theme-round-corners' : '';
        const enforceRoundCornersClass = props.blok?.enforceRoundCorners ? '--enforce-round-corners' : '';
        const hasBg = props.blok?.theme !== 'default' ? '--has-bg' : '';
        const bgClass = props.blok?.theme !== 'default' ? customTheme : '';
        const bgPosition = props.blok?.backgroundPosition !== 'default' ? backgroundPosition : '';
        const revertMobileLayout = props.blok?.revertMobileLayout ? '--revert-mobile-layout' : '';
        const hideFirstChildOnMobile = props.blok?.hideFirstChildOnMobile ? '--hide-first-child-mobile' : '';
        const hideSecondChildOnMobile = props.blok?.hideSecondChildOnMobile ? '--hide-second-child-mobile' : '';
        const verticalAlignment = props.blok?.verticalAlign !== 'top' && props.blok?.verticalAlign ? verticalAlign : '';

        return [
            customGridWeighting,
            widthClass,
            marginClass,
            marginDesktopClass,
            paddingClass,
            paddingDesktopClass,
            gapClass,
            gapDesktopClass,
            themeRoundCornersClass,
            enforceRoundCornersClass,
            hasBg,
            revertMobileLayout,
            hideFirstChildOnMobile,
            hideSecondChildOnMobile,
            verticalAlignment,
            bgClass,
            bgPosition
        ].filter(Boolean);
    });
</script>

<template>
    <PreviewBorder :visibility="props.blok?.visibility">
        <div
            v-if="!hidden"
            :id="props.blok?.anchorId"
            v-editable="props.blok"
            class="grid-wrapper double-row"
            :class="gridClasses"
        >
            <StoryblokComponentWrapper
                v-for="element in props.blok?.content"
                :key="element._uid"
                :blok="element"
            /></div
    ></PreviewBorder>
</template>

<style scoped lang="scss">
    @import '~/assets/scss/grid/grid.scss';
</style>
